import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {
  addIssuesToProjectPickerBulkMutation,
  UpdateIssuesBulkInput,
} from './__generated__/addIssuesToProjectPickerBulkMutation.graphql'

type AddToProjectUpdateArgs = {
  addToProjectV2Ids: string[]
  removeFromProjectV2Ids: string[]
}

export function commitAddIssuesToProjectPickerBulkMutation({
  environment,
  input: {ids, addToProjectV2Ids, removeFromProjectV2Ids},
  onCompleted,
  onError,
}: {
  environment: Environment
  input: {ids: string[]} & AddToProjectUpdateArgs
  onCompleted?: (response: addIssuesToProjectPickerBulkMutation['response']) => void
  onError?: (error: Error) => void
}) {
  const inputArgs = {addToProjectV2Ids, removeFromProjectV2Ids}
  const inputHash: UpdateIssuesBulkInput = {
    ids,
    ...inputArgs,
  }

  return commitMutation<addIssuesToProjectPickerBulkMutation>(environment, {
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    mutation: graphql`
      mutation addIssuesToProjectPickerBulkMutation($input: UpdateIssuesBulkInput!) @raw_response_type {
        updateIssuesBulk(input: $input) {
          jobId
        }
      }
    `,
    variables: {
      input: inputHash,
    },
    onCompleted: response => onCompleted && onCompleted(response),
    onError: error => onError && onError(error),
  })
}
